











import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import BaseButton from "@/components/BaseButton";
import BaseConfirmWithAvatar from "@/components/BaseConfirmWithAvatar";

export default defineComponent({
  name: "SlotNotAvailableConfirm",
  components: { BaseButton, BaseConfirmWithAvatar },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
  },
});
